export function useLinkify(text = '') {
    if (typeof text !== 'string') {
        return text;
    }

    const regex = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z\d][a-zA-Z\d-]+[a-zA-Z\d]\.\S{2,}|www\.[a-zA-Z\d][a-zA-Z\d-]+[a-zA-Z\d]\.\S{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z\d]+\.\S{2,}|www\.[a-zA-Z\d]+\.\S{2,})/g;

    return text.replaceAll(
        regex,
        '<a href="$1" target="_blank" rel="noreferrer noopener">$1</a>',
    );
}
